import { NavSegmentation24 } from 'ui/icons/aurora/24px/headerNav';
import { useRedirectToSegmentationWithSearchQuery } from 'modules/segmentation/navigation/hooks/useRedirectToSegmentationWithSearchQuery';
import { AllowedActionMenuElements } from 'ui/actionMenu/types';

import { createSegmentationSearchQuery } from '../components/AnonymousCriteriaTable/utils';

export const useCreateViewInSegmentationOption = ({
  criteriaId,
  isModernizedSegmentationPageEnabled,
}: {
  criteriaId: number;
  isModernizedSegmentationPageEnabled: boolean;
}) => {
  const segmentationOnClick = useRedirectToSegmentationWithSearchQuery({
    search: `?anonCriteriaId=${criteriaId}`,
    searchQuery: createSegmentationSearchQuery(criteriaId),
  });

  const viewInSegmentationOriginalOption = {
    id: 'view-in-segmentation',
    content: (
      <>
        <NavSegmentation24 />
        {'View in segmentation'}
      </>
    ),
    as: AllowedActionMenuElements.Link,
    href: `/segmentation?anonCriteriaId=${criteriaId}`,
  };

  const viewInSegmentationModernizedOption = {
    id: 'view-in-segmentation',
    content: (
      <>
        <NavSegmentation24 />
        {'View in segmentation'}
      </>
    ),
    as: AllowedActionMenuElements.Button,
    onClick: segmentationOnClick,
  };
  return isModernizedSegmentationPageEnabled
    ? viewInSegmentationModernizedOption
    : viewInSegmentationOriginalOption;
};
